<template>
  <div>
    <!-- <YA_ScrollComponent :scrollHeight="55"> -->
      <PowerFewShotMain ref="mainHeight" />

      <div>
        <PowerFewShotContent />
      </div>

      <v-footer inset padless>
        <YA_footer />
      </v-footer>
    <!-- </YA_ScrollComponent> -->
  </div>
</template>

<script>
import YA_footer from '@/components/WebBar/YA_footer.vue';
import YA_ScrollComponent from '@/components/WebBar/YA_ScrollComponent.vue';
import PowerFewShotMain from '@/components/PowerFewShot/PowerFewShotMain.vue';
import PowerFewShotContent from '@/components/PowerFewShot/PowerFewShotContent.vue';

export default {
  
  name: 'PowerFewShotView',
  components: {
    YA_footer,
    // YA_ScrollComponent,
    PowerFewShotMain,
    PowerFewShotContent
  },
  data() {
    return {

    }
  },
  created() {
    this.$store.watch(
      (state) => state.powerFewShotMsg.powerFewShotMainHeight, () => {
        if (this.$store.getters.getpowerFewShotMainHeight) {
          window.scrollTo({
            top: this.$refs.mainHeight.$el.clientHeight,
            behavior: 'smooth',
          });
          this.$store.commit('HandlepowerFewShotMainHeight', false);
        }
      }, {
        deep: true
      }
    );
  },
  mounted() {

  },

  methods: {

  }

};
</script>

<style scoped>
</style>